import services from "@/services";

export const actions = {
  async eleicaonetInfo({ commit }) {
    await services.Eleicaonet.loadEleicaonetInfo().then((response) => {
      commit("SET_ELEICAONET_INFO", response.data);
    });
  },
};
